import { useState } from "react";
import { format } from "date-fns";
import { CalendarClock, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const TIMES = ["08:00", "09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00", "18:00"];
const label = (t) => { const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "am" : "pm"}`; };

export default function SlotPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value) : undefined;
  const time = value ? value.slice(11, 16) : "10:00";
  const emit = (d, t) => { if (d) onChange(`${format(d, "yyyy-MM-dd")}T${t}`); };
  return (
    <div className="flex items-center gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid="filter-slot" className={`flex items-center gap-2 px-4 min-h-[48px] rounded-xl border bg-white font-medium text-slate-700 hover:border-[#2E7D6B] transition-colors ${value ? "border-[#2E7D6B]" : "border-[#E2D9CE]"}`}>
            <CalendarClock className="w-5 h-5 text-[#2E7D6B]" />
            {date ? `Free ${format(date, "EEE d MMM")} at ${label(time)}` : "Free at…"}
          </button>
        </PopoverTrigger>
        <PopoverContent data-testid="slot-popover" align="start" className="w-auto p-4 rounded-2xl border-[#E2D9CE] bg-[#FAF8F5]">
          <p className="font-semibold text-slate-800 mb-1">Pick a day</p>
          <Calendar mode="single" selected={date} onSelect={(d) => emit(d, time)} disabled={{ before: new Date() }} className="p-0 [&_button]:h-11 [&_button]:w-11 [&_button]:text-base" />
          <p className="font-semibold text-slate-800 mt-3 mb-2">and a time</p>
          <div className="grid grid-cols-5 gap-2">
            {TIMES.map((t) => (
              <button key={t} type="button" data-testid={`slot-time-${t.replace(":", "")}`} onClick={() => { emit(date || new Date(Date.now() + 86400000), t); if (date) setOpen(false); }}
                className={`min-h-[44px] rounded-xl text-sm font-semibold border transition-colors ${time === t && value ? "bg-[#2E7D6B] text-white border-[#2E7D6B]" : "bg-white border-[#E2D9CE] hover:border-[#2E7D6B]"}`}>{label(t)}</button>
            ))}
          </div>
          <button type="button" data-testid="slot-done-btn" onClick={() => setOpen(false)} className="mt-4 w-full bg-[#D96B43] hover:bg-[#C25832] text-white font-semibold min-h-[48px] rounded-xl">Done</button>
        </PopoverContent>
      </Popover>
      {value && <button type="button" data-testid="clear-slot-btn" onClick={() => onChange("")} aria-label="Clear time" className="w-11 h-11 rounded-full border border-[#E2D9CE] bg-white flex items-center justify-center text-slate-500 hover:text-red-600 hover:border-red-300"><X className="w-5 h-5" /></button>}
    </div>
  );
}
